import { VIRTUAL_CALL_NEED_RECOVER_HISTORY } from '@/utils/constants';
import { saveDataToLocalStorage } from '@/utils/bridges/localStorage';

export class ChatbotCommonVariable {
  popWebViewLock = false; // pop webview 的 lock 点击一次之后会锁住 防止再次点击
  virtualCallNeedRecoverHistory = false; // 是否在 vc 状态中 在的话需要恢复之前的 记录


  constructor() {}

  UPDATE_POP_WEB_VIEW_LOCK = (val: boolean) => {
    this.popWebViewLock = val;
  };

  UPDATE_VIRTUAL_CALL_NEED_RECOVER_HISTORY = (val: boolean, onlyInside = false) => {
    this.virtualCallNeedRecoverHistory = val;
    if (!onlyInside) {
      saveDataToLocalStorage(VIRTUAL_CALL_NEED_RECOVER_HISTORY, val + '');
    }
  };
}

const chatbotCommonVariable = new ChatbotCommonVariable();

export default chatbotCommonVariable;

export interface GetCallbackParamsData {
  thread_id?: string | number;
  round_id?: string | number;
  thread_id_v2?: string | number;
  threadId?: string | number;
  roundId?: string | number;
  threadIdV2?: string | number;
}
export const getCallbackParams = (data?: GetCallbackParamsData, other?: any) => {
  const params: GetCallbackParamsData = {};
  const thread_id = data?.thread_id ?? data?.threadId ?? other?.thread_id;
  const round_id = data?.round_id ?? data?.roundId ?? other?.round_id;
  const thread_id_v2 = data?.thread_id_v2 ?? data?.threadIdV2 ?? other?.thread_id_v2;
  if (thread_id) {
    params.thread_id = thread_id;
  }
  if (round_id) {
    params.round_id = round_id;
  }
  if (thread_id_v2) {
    params.thread_id_v2 = thread_id_v2;
  }
  return params;
};

export const InternetCallRNLink = 'rn/@shopee-rn/virtualcall-plugin/CALL';
export const isInternetCallLink = (url = '') => {
  return url?.includes?.(InternetCallRNLink);
};
export const getInternetCallLink = (url = '') => {
  if (isInternetCallLink(url)) {
    const param = '__anim__=3';
    return url.includes('?') ? `${url}&${param}` : `${url}?${param}`;
  } else {
    return url;
  }
};

export const webformNewApiCheckMultipleActionParams = { interaction_cmd: 'check_multiple_action' };
export const webformNewApiSubmitActionParams = { interaction_cmd: 'submit_webform_action' };

